import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.vue'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import Configuration from '@/agilis/util/Configuration'

import { mapActions, mapGetters } from 'vuex'

const TRACKER_TYPE_CONTACT = 'contact2'

export default {
  name: 'Company2TableItemView',

  components: {
    TrackerDataTableView,
    UnStyledLink
  },

  data () {
    return {
      contacts: [],
      contactsLoaded: false
    }
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading',
      dataTableById: 'contextStore/trackerDataTableById',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      userId: 'userDataStore/userId',
      selectedContext: 'contextStore/selectedContext'
    }),

    contactColumns () {
      const contactDataTable = this.dataTableById(TRACKER_TYPE_CONTACT)

      return [
        contactDataTable.columns.lastName,
        contactDataTable.columns.firstName,
        contactDataTable.columns.title,
        contactDataTable.columns.email,
        contactDataTable.columns.phoneMobile,
        contactDataTable.columns.phoneWork
      ]
    },

    userCanAddNewContact () {
      const hideCreateButton = `/${this.applicationId}`
        .concat(`/workspace/${this.workspaceId}`)
        .concat(`/tracker/${TRACKER_TYPE_CONTACT}`)
        .concat(`/datatable/hideCreateButton`)
      return this.userCanDo('post') && !Configuration.auth.userHasPrivilege(hideCreateButton)
    },

    contactContext () {
      return Object.assign(
        {},
        this.selectedContext,
        {
          parentTrackerId: null,
          trackerId: null, // <<< will not change permissions, we don't need to re-compute context for each contact
          trackerTypeId: TRACKER_TYPE_CONTACT
        }
      )
    },

    routeBackToCompanyCallback () {
      const routeToCompany = {
        trackerId: this.selectedContext.trackerId,
        trackerTypeId: this.selectedContext.trackerTypeId
      }
      return () => {
        this.$router.agilis.viewTracker(routeToCompany)
      }
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'startLoader': 'loaderStore/startLoader',
      'stopLoader': 'loaderStore/stopLoader'
    }),

    trackerReady (trackerDTO) {
      if (trackerDTO && trackerDTO.id) {
        this.loadContacts(trackerDTO)
        return true
      }
      return false
    },

    userCanDo (operation) {
      return Configuration.auth.userCanDo(this.selectedContext, operation, this.trackerDTO, this.userId)
    },

    loadContacts: async function (trackerDTO) {
      const myLoader = { id: 'contacts-details' }

      if (!this.contactsLoaded && trackerDTO.id) {
        this.contactsLoaded = true
        this.startLoader(myLoader)
        try {
          const url = this.$axios.agilisUrlDataTableSearch('/api/sales/contact2')
          const body = {
            filterTerms: [
              { field: 'company.trackerId', operator: 'EQUALS', value: parseInt(trackerDTO.id) }
            ],
            sortTerms: [
              { sortField: 'lastName', sortType: 'ASC' }
            ]
          }

          const config = this.$axios.agilisRequestConfig(url)
          const response = await this.$axios.post(url, body, config)

          this.contacts = response.data.items.map(c => ({
            id: c.id,
            firstName: c.firstName,
            lastName: c.lastName,
            title: c.title,
            email: c.email,
            phoneMobile: c.phoneMobile,
            phoneWork: c.phoneWork
          }))
        } catch (error) {
          this.notifyError(error)
        }
        this.stopLoader(myLoader)
      }
    },

    addNewContact (trackerDTO) {
      // prefill address and route to "new contact"
      this.$router.agilis.copyTracker({
        trackerTypeId: TRACKER_TYPE_CONTACT,
        data: {
          company: { id: parseInt(trackerDTO.id) },
          street: trackerDTO.street,
          city: trackerDTO.city,
          state: trackerDTO.state,
          postalCode: trackerDTO.postalCode,
          country: trackerDTO.country
        },
        next: this.routeBackToCompanyCallback
      })
    },

    viewContact (contact) {
      // route to view of tracker contact
      this.$router.agilis.viewTracker({
        trackerId: contact.id,
        trackerTypeId: TRACKER_TYPE_CONTACT,
        next: this.routeBackToCompanyCallback
      })
    },

    editContact (contact) {
      // route to edit of tracker contact
      this.$router.agilis.editTracker({
        trackerId: contact.id,
        trackerTypeId: TRACKER_TYPE_CONTACT,
        next: this.routeBackToCompanyCallback
      })
    },

    urlViewContact (contact) {
      // url to view of tracker contact
      return this.$router.agilis.urlViewTracker({
        trackerId: contact.id,
        trackerTypeId: TRACKER_TYPE_CONTACT
      })
    },

    urlEditContact (contact) {
      // url to edit of tracker contact
      return this.$router.agilis.urlEditTracker({
        trackerId: contact.id,
        trackerTypeId: TRACKER_TYPE_CONTACT
      })
    },

    renderContactColumn (colConfig, childTracker) {
      return Configuration.datatable.renderColumn(colConfig, childTracker) || ' '
    },

    userCanEditContact (item) {
      return Configuration.auth.userCanDo(this.contactContext, 'put', item, this.userId)
    },

    userCanViewContact (item) {
      return Configuration.auth.userCanDo(this.contactContext, 'get', item, this.userId)
    },

    userCanAccessFeature (featureId) {
      return Configuration.auth.userCanAccessFeature(
        this.selectedContext, featureId, null, this.trackerDTO, this.userId)
    }
  }
}
